import { useSectionMetaData } from '@v4/components/common/SectionItem'
import { FOOTER_VARIANTS } from '@v4/components/sections/Sections.const'
import useStyles from './Footer.styled'

export const useFooter = ({ variant = FOOTER_VARIANTS.VARIANT_1, Element }) => {
	const metaData = useSectionMetaData()
	const classes = useStyles()

	return [
		{
			classes,
			metaData,
			Element,
			variant,
		},
	]
}
